<template>
	<div style="overflow: hidden;">
		<div class="news-block">
			<div class="news-box" v-for="(item, index) in newsList" @click="toNewsDetails(item.id)">
				<img :src="$imgUrl + item.listImgPc" alt="" class="left-image">
				<div class="right">
					<div class="news-title">
						{{item.title}}
					</div>
					<div class="news-content">
						{{item.shortTitle}}
					</div>
					<div class="bottom">
						{{$moment(item.createdTime).format('YYYY[年] MM/DD')}}
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getNews"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data () {
			return {
				params: {
					current: 1,
					size: 6,
					channelId: this.$store.state.channelId,
					releaseTerrace: "releasePc"
				},
				newsList: [],
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_1.png'
		},
		methods: {
			getNews(news) {
				document.body.scrollTop = document.documentElement.scrollTop = 0
				this.newsList = news
			},
			toNewsDetails(newsId) {
				this.$router.push({
					path: '/yjdt_xqy',
					query: {
						news_id: newsId
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.news-block {
		width: 60%;
		margin: 0 20%;
		padding: 15px 0 40px;
		.news-box {
			margin-bottom: 15px;
			display: flex;
			width: 100%;
			border-bottom: 3px solid #a21c2a;
			cursor: pointer;
			.left-image {
				width: 315px;
				height: 100%;
			}
			.right {
				width: 100%;
				height: 100%;
				padding: 25px;
				.news-title {
					color: #264EA7;
					font-size: 18px;
					overflow: hidden;
					text-overflow: ellipsis;
					text-align: left;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					line-clamp: 1;
					-webkit-box-orient: vertical;
				}
				.news-content {
					color: #333333;
					font-size: 18px;
					text-align: left;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					margin-top: 30px;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
				}
				.bottom {
					height: 30px;
					margin-top: 20px;
					line-height: 30px;
					text-align: right;
					color: #686868;
					font-size: 18px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/news/yjdt.vue